import { toSafeNumber } from '@/services/tariffs/tariffValueNormalizer'

const UNKNOWN_CAPABILITY = Object.freeze({
    lookupKey: null,
    name: null,
    rawValue: null,
    isAvailable: false,
    isUnlimited: false,
    isKnown: false,
})

export function getFeatureCapability(accessMap, featureKey) {
    const row = accessMap instanceof Map ? accessMap.get(featureKey) : undefined

    if (!row) {
        return { ...UNKNOWN_CAPABILITY, lookupKey: featureKey }
    }

    return { ...row, isKnown: true }
}

export function isFeatureAvailable(accessMap, featureKey) {
    return getFeatureCapability(accessMap, featureKey).isAvailable
}

export function isFeatureUnlimited(accessMap, featureKey) {
    const capability = getFeatureCapability(accessMap, featureKey)
    return capability.isAvailable && capability.isUnlimited
}

export function getFeatureLimit(accessMap, featureKey) {
    const capability = getFeatureCapability(accessMap, featureKey)

    if (!capability.isAvailable || capability.isUnlimited) {
        return null
    }

    return toSafeNumber(capability.rawValue)
}
